import PropTypes from 'prop-types';
import React, { Component } from 'react';
import immutableCreatorSelector from '../../selectors/immutableCreatorSelector';
import { connect } from 'react-redux';
import { Map } from 'immutable';

import { ModalActions } from '../../actions/modal';
import '../../styles/SmallModal.css';

class DeleteConfirmation extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    modal: PropTypes.instanceOf(Map),
  }

  constructor(props) {
    super(props);

    this.onClose = this.onClose.bind(this);
    this.onHandleDelete = this.onHandleDelete.bind(this);
  }

  onClose = () => {
    const { dispatch } = this.props;
    dispatch(ModalActions.hideModal());
  }

  onHandleDelete = () => {
    const { modal, dispatch } = this.props;
    const handleDelete = modal.getIn(['options', 'handleDelete']);
    handleDelete();
    dispatch(ModalActions.hideModal());
  }

  deleteTypeMap = {
    account: 'Are you sure you want to delete this account?',
    organization: 'Are you sure you want to delete this organization?',
    element: 'Deleting this element will affect all relationships using this element. All children of this element will also be deleted. Are you sure you want to delete this element?',
    multiElements: 'Deleting these elements will affect all relationships using these elements. Are you sure you want to delete these elements?',
    elementType: 'Deleting this element type will affect all elements using this element type. Are you sure you want to delete this element type?',
    elementTypeProperty: 'Deleting this property will affect all elements using this element type property. Are you sure you want to delete this property?',
    project: 'Deleting this project will affect all elements, types, relationships, and users. Are you sure you want to delete this project?',
    relationship: 'Are you sure you want to delete this relationship?',
    relationships: 'Are you sure you want to delete these relationships?',
    relationshipType: 'Deleting this relationship type will affect all relationships using this relationship type. Are you sure you want to delete this relationship type?',
    relationshipTypeProperty: 'Deleting this property will affect all relationships using this relationship type property. Are you sure you want to delete this property?',
    view: 'This view will be permanently deleted. Are you sure?',
    tag: 'This tag will be permanently deleted and will be removed from all elements and relationships. Are you sure?',
    projectUser: 'Are you sure you want to remove the user from this project?',
    baseline: 'Are you sure you want to delete this baseline?',
    dailyTaskCompleteReport: 'Are you sure you want to delete this daily task complete report?',
  };

  render() {
    const { modal } = this.props;
    const deleteType = modal.getIn(['options', 'deleteType']);
    const name = modal.getIn(['options', 'name'], null);
    const confirmText = modal.getIn(['options', 'confirmText'], null);

    let nameDisplay = name ? ` - You are about to delete ${name}` : '';
    let confirmTextDisplay = confirmText || 'Delete';

    return (
      <div className="fs-modal-content">
        <h4 style={{
          width: '100%',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
        >Warning {nameDisplay}</h4>
        <div className="modal-body modal-form-wrapper">
          <p className="my-3">{this.deleteTypeMap[deleteType]}</p>
        </div>
        <div className="modal-form-button-wrapper" style={{ float: 'right', padding: 10 }}>
          <button
            type="button"
            className="btn btn-outline-secondary mr-1"
            data-dismiss="modal"
            onClick={this.onClose}
          >Close</button>
          <button
            type="button"
            className="btn btn-danger"
            data-test="deleteButton"
            onClick={this.onHandleDelete}
          >{confirmTextDisplay}</button>
        </div>
      </div>
    );
  }
}

const modalSelector = (state) => state.modal.get('modals').last();
const DeleteConfirmationSelector = immutableCreatorSelector(
  [modalSelector],
  (modal) => ({
    modal,
  })
);
@connect(DeleteConfirmationSelector)
export default class DeleteConfirmationContainer extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
  }

  render() {
    return (
      <DeleteConfirmation {...this.props} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/modals/DeleteConfirmationModal.js